import { get, onValue, ref } from "firebase/database";
import types from "../types";
import { db } from "../lib/firebase";
import { ADVERTISER_ROLE, THEME_ID_PROJECT } from "../utils/constants";
import { ConfirmAlert, SimpleAlert } from "../components/Alerts/Alerts";
import i18next from "i18next";
import {
  BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON,
  BUTTON_GO_BACK,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION,
  OK,
} from "../i18n/keysTranslations";

export const setOpenNotification = (state) => ({
  type: types.UI_SET_OPEN_NOTIFICATION,
  payload: {
    open: state.open,
    message: state.message ?? "",
    horizontal: state.horizontal ?? "right",
    vertical: state.vertical ?? "bottom",
    action: state.action,
  },
});
export const setShowBackdrop = (state) => ({
  type: types.UI_SET_SHOW_BACKDROP,
  payload: state,
});
export const setOpenSlideMenu = (open) => ({
  type: types.UI_SET_OPEN_SLIDE_MENU,
  payload: open,
});
export const resetUIReducer = () => ({
  type: types.RESET_UI_STATE,
});
export const setShowModalSelectSubscription = (open) => ({
  type: types.UI_SHOW_MODAL_SELECT_SUBSCRIPTION,
  payload: open,
});
export const setModalOpenState = (modalName, isOpen) => ({
  type: types.UI_SET_MODAL_OPEN_STATE,
  payload: { modalName, isOpen },
});

export const showBrandUsageLimitAlert = () => async (dispatch, getState) => {
  const userRole = getState()?.auth?.user?.role;
  const isAdministrator = userRole === ADVERTISER_ROLE;

  if (isAdministrator) {
    const result = await ConfirmAlert({
      title: i18next.t(NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: i18next.t(BUTTON_GO_BACK),
      confirmButtonText: i18next.t(BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON),
    });

    if (result.isConfirmed) {
      dispatch(setModalOpenState("isModalConfigureBrandLimits", true));
    }
    return;
  }

  await SimpleAlert({
    title: i18next.t(NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE),
    text: i18next.t(NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION),
    confirmButtonText: i18next.t(OK),
    icon: "warning",
  });
};
export const setNotificationsPanelIsClosed = (userClosed) => ({
  type: types.UI_SET_NOTIFICATIONS_PANEL_IS_CLOSED,
  payload: userClosed,
});
export const setNotificationsPanelIsExpanded = (isExpanded) => ({
  type: types.UI_SET_NOTIFICATIONS_PANEL_IS_EXPANDED,
  payload: isExpanded,
});
export const setNotificationsPreviousAlerts = (alerts) => ({
  type: types.UI_SET_NOTIFICATIONS_PREVIOUS_NOTIFICATIONS,
  payload: alerts,
});

export const startGetVersionAds = () => async (dispatch) => {
  try {
    const dbRef = ref(db, `versions/ads`);
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      dispatch(setVersion(data));
    });
  } catch (error) {
    console.log(error);
    return false;
  }
};
const setVersion = (data) => ({
  type: types.SET_VERSION,
  payload: data,
});
export const startGetLastDateTimeInsights = () => async (dispatch) => {
  try {
    const dbRef = ref(db, `lastDateTimeInsights`);
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      dispatch(setLastDateTimeInsights(data));
    });
  } catch (error) {
    console.log("error");
    console.log(error);
    return false;
  }
};
const setLastDateTimeInsights = (data) => ({
  type: types.SET_LAST_DATE_TIME_INSIGHTS,
  payload: data,
});

export const startGetProgressValues =
  ({ progressID, onCallbackUpdateProgress, onReferenceAvailable }) =>
  async () => {
    try {
      const dbRef = ref(db, progressID);
      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();

        if (!data) return;
        onCallbackUpdateProgress(data);
      });
      onReferenceAvailable(dbRef);
    } catch (error) {
      console.log(error);
      return false;
    }
  };

export const startGetTheme = () => async (dispatch) => {
  try {
    const dbRef = ref(db, `themes/${THEME_ID_PROJECT}`);

    const snapshot = await get(dbRef);

    if (snapshot.exists()) {
      dispatch(setTheme(snapshot.val()));
    }

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
const setTheme = (data) => ({
  type: types.UI_SET_THEME,
  payload: data,
});
